<template>
  <div class="main">
    <tab title="对账"></tab>
    <div class="choose_time">
      <div class="choose_title">请选择对账时间段</div>
      <div class="time_box">
        <div class="time">
          开始时间
          <div class="choose_box" @click="start_show = true">
            {{ start_time }}
          </div>
        </div>
        <div class="time">
          结束时间
          <div class="choose_box" @click="end_show = true">{{ end_time }}</div>
        </div>
      </div>
      <div class="choose_search" @click="setstate">开始对账</div>
    </div>
    <van-popup v-model="start_show" :round="true">
      <div class="timeChoose">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="选择开始时间"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="start_formatter"
          @confirm="start_confirm"
          @cancel="start_cancel"
        />
      </div>
    </van-popup>
    <van-popup v-model="end_show" :round="true">
      <div class="timeChoose">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="选择结束时间"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="start_formatter"
          @confirm="end_confirm"
          @cancel="end_cancel"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import tab from "@/components/NavBar";
import Vue from "vue";
import { Toast } from "vant";
import { Popup } from "vant";
import { DatetimePicker } from "vant";

Vue.use(DatetimePicker);

Vue.use(Popup);

Vue.use(Toast);

export default {
  data() {
    return {
      state: 0,
      start_show: false,
      end_show: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      start_time: "",
      end_time: "",

      dataCharge: [],
      dataAssign: [],
      dataOrder: [],
      balance: "",
      orgCustName: "",
    };
  },
  components: {
    tab,
  },
  mounted() {
    //   this.getOrderDetailInfo()
  },
  methods: {
    dateToTimestamp(dateStr) {
        if (!dateStr) {
            return ''
        }
        let newDataStr = dateStr.replace(/\.|\-/g, '/')
        let date = new Date(newDataStr);
        let timestamp = date.getTime();
        return timestamp
    },
    setstate() {
      
      var startTime = this.dateToTimestamp(this.start_time)
      var endTime = this.dateToTimestamp(this.end_time)
      

      if(!startTime){
          Toast('请选择开始时间')
          return
      }
      if(!endTime){
          Toast('请选择结束时间')
          return
      }
      if(startTime>endTime){
          this.start_time = ''
          this.end_time = ''
          Toast('结束时间不能大于开始时间')
          return
      }
      this.state = 1;
      //   this.getOrderDetailInfo();
      this.$router.push({
        name: "reconciliation",
        params: { start_time: this.start_time,end_time:this.end_time },
      });

      
    },
    start_cancel() {
      this.start_show = false;
    },
    start_confirm(val) {
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      console.log(`${year}-${month}-${day}-${hour}-${minute}`);
      this.start_time = `${year}-${month}-${day}`;
      this.start_show = false;
      return `${year}-${month}`;
    },
    end_cancel() {
      this.end_show = false;
    },
    end_confirm(val) {
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      console.log(`${year}-${month}-${day}-${hour}-${minute}`);
      this.end_time = `${year}-${month}-${day}`;
      this.end_show = false;
      return `${year}-${month}`;
    },
    start_formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
  },
};
</script>

<style scoped>
.main {
  background-color: #f7f8fa;
  height: 100vh;
  text-align: center;
}
.choose_time {
  width: 85%;
  height: 200px;
  padding: 0 20px;
  border-radius: 5px;
  background-color: #fff;
  margin: auto;
  margin-top: 114px;
  position: relative;
}
.choose_title {
  width: 160px;
  height: 57px;
  line-height: 76px;
  text-align: center;
  border-bottom: 1px solid #1989FA;
  color: #1989FA;
  margin: auto;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 10px;
}
.time_box {
  /* display: flex; */
  width: 69%;
  margin: auto;
}
.time {
  margin-left: 5px;

  display: flex;
  line-height: 25px;
  margin-top: 15px;
}
.choose_box {
  height: 25px;
  width: 150px;
  border: 1px solid #1989FA;
  border-radius: 5px;
  margin-left: 5px;
}
.choose_search {
  animation: myAnimation 5s infinite;
  margin: auto;
  margin-top: 10px;
  width: 56%;
  height: 30px;
  border-radius: 5px;
  color: #fff;
  background-color: #1989FA;
  line-height: 30px;
  text-align: center;
}
@keyframes myAnimation{
  0%{
    transform: scale(1)
  }
  25%{
    transform: scale(1.2)
  }
  50%{
    transform: scale(1)
  }
  75%{
    transform: scale(1.2)
  }
}
.basic_info {
  width: 85%;
  height: 124px;
  padding: 0 20px;
  border-radius: 5px;
  background-color: #fff;
  margin: auto;
  margin-top: 34px;
  position: relative;
}
.info_title {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #fff;
  position: absolute;
  top: -15px;
  left: 40%;
  border: 1px solid #169bd5;
  border-radius: 5px;
}
.info_box {
  overflow: hidden;
}
.info {
  width: 80%;
  line-height: 30px;
  margin: auto;
  display: flex;
  margin-top: 30px;
}
.name_show {
  width: 160px;
  height: 30px;
  border-radius: 5px;
  border: 1px solid #169bd5;
  margin-left: 5px;
  font-size: 14px;
}
.the_detail {
  width: 85%;
  min-height: 300px;
  padding: 0 20px;
  border-radius: 5px;
  background-color: #fff;
  margin: auto;
  margin-top: 20px;
  position: relative;
}
.table_box {
  overflow: hidden;
}
.table {
  width: 90%;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 20px;
}
table,
td,
th {
  width: 100%;
  border: 1px solid #ccc;
  text-align: center;
}
th {
  width: 100%;
  border: 2px solid #ccc;
  text-align: center;
  height: 30px;
}
.tr_title {
  width: 100%;
}
.tr_title td {
  width: 33%;
  height: 30px;
}
.timeChoose {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/chooseTIme.vue